import React from "react";
import { normalizeString } from "../../util/util";
import CourseCard from "../Carousel/CourseCard";
import * as S from "./styles";

const CardsGridContainer = ({
  content = [],
  link = "",
  showItemTitle = false,
}) => {
  return (
    <S.Wrapper>
      {content.map((item, index) => (
        <CourseCard
          key={normalizeString(item.slug + index)}
          slug={item.slug}
          image={item.images.thumbUrl}
          title={item.name}
          bigCard
          showItemTitle={showItemTitle}
          link={link}
        />
      ))}
    </S.Wrapper>
  );
};

export default CardsGridContainer;
